<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Client</mat-label>
      <input *ngIf="!data.clients" matInput formControlName="clientName" type="text" placeholder="Client" />
      <mat-select *ngIf="data.clients" matInput formControlName="clientName" placeholder="Client">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let client of data.clients" [value]="client.name">{{ client.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ifb-user-email-input [fc]="form.get('username')" baseFilterItem></ifb-user-email-input>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>First name</mat-label>
      <input matInput formControlName="firstName" type="text" placeholder="First name" />
      <button
        type="button"
        *ngIf="form.get('firstName').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('firstName').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Last name</mat-label>
      <input matInput formControlName="lastName" type="text" placeholder="Last name" />
      <button
        type="button"
        *ngIf="form.get('lastName').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('lastName').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>External ID</mat-label>
      <input matInput formControlName="externalId" type="text" placeholder="External ID" />
      <button
        type="button"
        *ngIf="form.get('externalId').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('externalId').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <ifc-filter-param-date-range-input
      [fc]="form.get('lastLogin')"
      [label]="'Date of last login'"
      (rangeSelected)="lastLoginDateSelected($event)"
    ></ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('lastLogin').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('lastLoginStart')"
        [label]="'Date of last login start'"
        baseFilterItem
      ></ifc-datepicker>

      <ifc-datepicker
        [fc]="form.get('lastLoginEnd')"
        [label]="'Date of last login end'"
        baseFilterItem
      ></ifc-datepicker>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
